.iframe {
  border: none;
  height: calc(var(--mirai-ui-space-XXL) * 10);
  width: 100%;
}
